import { AfterViewInit, Component, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { EventEmitter } from '@angular/core';
import { ModalPopupType } from '../../models/modalPopupType';
import { DeleteValitaion, UserListDto } from '@shared/service-proxies/service-proxies';

@Component({
  standalone: false,
  selector: 'app-modal-delete-validation',
  templateUrl: './modal-delete-validation.component.html',
  styleUrls: ['./modal-delete-validation.component.css']
})
export class ModalDeleteValidationComponent implements OnInit  ,AfterViewInit{
  @ViewChild("template") template: TemplateRef<any>;
  @Output() clickedYes = new EventEmitter<{
    userdatalist: UserListDto[];
    validation: DeleteValitaion;
   
}>();
  @Output() clickedCancel = new EventEmitter<any>();
  result: DeleteValitaion
 userId: number;
  modalType: ModalPopupType;
  modalRef: BsModalRef;
  userdatalist :UserListDto[] = [];
  config = {
      animated: true,
      class: "modal-dialog-centered",
  };
 
  constructor(private bsModalService: BsModalService) { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
  }

  show(data: DeleteValitaion ,userdata: any) {
     this.result = data;
     this.userdatalist = userdata;
          this.modalRef = this.bsModalService.show(this.template, this.config);
 
  }

  yes() {
    this.clickedYes.emit({userdatalist :this.userdatalist,validation:this.result} );
    this.modalRef.hide();
}

cancel() {
    this.modalRef.hide();
}


openReporteesTasksInNewTab(manager: any) {

}   

}
